import * as React from "react"
export const SvgComponent = ({ title, handlePlate, ...props }) => (
  <div className="svgContainer">
    <h2>{title}</h2>
    <svg
    width={700} height={700}
    id="Capa_1"
    data-name="Capa 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 587.82 839.6"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1, .cls-2 {  fill: #1f140f;}.cls-2 {  font-family: MyriadPro-Regular, 'Myriad Pro';  font-size: 20px;}.cls-2, .cls-3 {  isolation: isolate;}.cls-4 {  fill: #fff;}.cls-4, .cls-5 {  stroke: #1f140f;  stroke-miterlimit: 10;}.cls-5 {  fill: none;}    "
        }
      </style>
    </defs>
    <g id="Capa_1-2" data-name="Capa 1-2">
      <ellipse
        className="cls-4"
        cx={295.55}
        cy={785.77}
        rx={199.33}
        ry={53.33}
      />
      <rect
        className="cls-4"
        x={145.8}
        y={48.52}
        width={296.43}
        height={732.32}
      />
      <path
        className="cls-4"
        d="m145.8,780.84c0,12.61,66.36,22.83,148.21,22.83s148.21-10.22,148.21-22.83-66.36-22.83-148.21-22.83-148.21,10.22-148.21,22.83"
      />
      <ellipse
        className="cls-4"
        cx={294.02}
        cy={48.14}
        rx={148.21}
        ry={16.38}
      />
    </g>
    <g id="Capa_2" data-name="Capa 2">
      <path
        className="cls-1"
        d="m442.5,208.95c2.27-8.55,6.53-16.52,12.22-23.29s12.76-12.34,20.7-16.22c4.46-2.18,9.18-3.79,14.05-4.79.63-.13.36-1.09-.27-.96-8.8,1.8-17.12,5.65-24.31,11.01s-13.26,12.19-17.66,19.99c-2.48,4.4-4.41,9.1-5.71,13.98-.17.62.8.89.96.27h.02Z"
      />
      <line className="cls-5" x1={489.34} y1={164.18} x2={569.85} y2={164.18} />
      <rect
        className="cls-5"
        x={480.88}
        y={78.43}
        width={106.44}
        height={86.22}
      />
      <line className="cls-5" x1={480.6} y1={78.43} x2={450.23} y2={0.66} />
      <line className="cls-5" x1={586.59} y1={78.43} x2={541.61} y2={0.5} />
      <line className="cls-5" x1={450.23} y1={0.66} x2={541.61} y2={0.5} />
      <line className="cls-5" x1={480.45} y1={160.05} x2={452.9} y2={64.15} />
      <line className="cls-5" x1={450.23} y1={0.66} x2={452.9} y2={64.15} />
      <line className="cls-5" x1={489.34} y1={164.18} x2={442.23} y2={165.33} />
      <line className="cls-5" x1={442.26} y1={155.97} x2={480.88} y2={156.59} />
      <path
        className="cls-1"
        d="m146.29,216.13c-2.3-8.67-6.62-16.72-12.36-23.59s-12.96-12.57-21.02-16.51c-4.54-2.22-9.34-3.88-14.29-4.89-.63-.13-.9.84-.27.96,8.66,1.77,16.83,5.54,23.92,10.8,7.1,5.27,13.1,12.04,17.44,19.74,2.44,4.33,4.33,8.94,5.6,13.74.17.62,1.13.36.96-.27h0l.02.02h0Z"
      />
      <line className="cls-5" x1={98.48} y1={171.62} x2={17.98} y2={171.62} />
      <rect className="cls-5" x={0.5} y={85.88} width={106.44} height={86.22} />
      <line className="cls-5" x1={107.22} y1={85.87} x2={137.59} y2={8.1} />
      <line className="cls-5" x1={1.24} y1={85.87} x2={46.22} y2={7.94} />
      <line className="cls-5" x1={137.59} y1={8.1} x2={46.22} y2={7.94} />
      <line className="cls-5" x1={107.38} y1={167.49} x2={134.93} y2={71.59} />
      <line className="cls-5" x1={137.59} y1={8.1} x2={134.93} y2={71.59} />
      <line className="cls-5" x1={98.48} y1={171.62} x2={145.59} y2={172.77} />
      <line className="cls-5" x1={145.56} y1={163.41} x2={106.94} y2={164.03} />
    </g>
    <g id="Capa_8" data-name="Capa 8">
      <rect
        className="cls-4"
        x={218.56}
        y={208.82}
        width={148}
        height={408.96}
      />
      <line className="cls-5" x1={218.56} y1={208.82} x2={234.44} y2={193.94} />
      <line className="cls-5" x1={366.56} y1={208.82} x2={376.66} y2={193.94} />
      <line className="cls-5" x1={234.44} y1={193.94} x2={376.66} y2={193.94} />
      <line className="cls-5" x1={376.66} y1={193.94} x2={376.66} y2={610.88} />
      <line className="cls-5" x1={366.56} y1={617.78} x2={376.66} y2={610.88} />
    </g>
    <g id="Capa_10" data-name="Capa 10">
      <g className="cls-3">
        <text className="cls-2" transform="translate(248.82 190.42)">
          <tspan x={0} y={0}>
            {"1"}
          </tspan>
        </text>
      </g>
      <g className="cls-3">
        <text className="cls-2" transform="translate(271.17 189.82)">
          <tspan x={0} y={0}>
            {"2"}
          </tspan>
        </text>
      </g>
      <g className="cls-3">
        <text className="cls-2" transform="translate(294.82 190.42)">
          <tspan x={0} y={0}>
            {"3"}
          </tspan>
        </text>
      </g>
      <g className="cls-3">
        <text className="cls-2" transform="translate(318.62 190.62)">
          <tspan x={0} y={0}>
            {"4"}
          </tspan>
        </text>
      </g>
      <g className="cls-3">
        <text className="cls-2" transform="translate(344.13 190.42)">
          <tspan x={0} y={0}>
            {"5"}
          </tspan>
        </text>
      </g>
    </g>
    <g id="FlindersBoxes" data-name="FlindersBoxes">
      <ellipse
        onClick={e => handlePlate(e)}
        className="cls-5"
        cx={252.1}
        cy={201.38}
        rx={6.58}
        ry={3.98}
        transform="translate(-70.53 197.29) rotate(-37.89)"
      />
      <ellipse
        onClick={e => handlePlate(e)}
        className="cls-5"
        cx={276.04}
        cy={201.38}
        rx={6.58}
        ry={3.98}
        transform="translate(-65.49 211.99) rotate(-37.89)"
      />
      <ellipse
        onClick={e => handlePlate(e)}
        className="cls-5"
        cx={300.56}
        cy={201.38}
        rx={6.58}
        ry={3.98}
        transform="translate(-60.32 227.06) rotate(-37.89)"
      />
      <ellipse
        onClick={e => handlePlate(e)}
        className="cls-5"
        cx={324.98}
        cy={201.38}
        rx={6.58}
        ry={3.98}
        transform="translate(-55.17 242.06) rotate(-37.89)"
      />
      <ellipse
        onClick={e => handlePlate(e)}
        className="cls-5"
        cx={350.67}
        cy={201.38}
        rx={6.58}
        ry={3.98}
        transform="translate(-49.75 257.83) rotate(-37.89)"
      />
    </g>
  </svg>
  </div>
)
